<template>
  <div class="chats">
    <ticket-message :message="ticket" />
    <ticket-message
      v-for="(comment,key) in ticket.comments"
      :key="key"
      :message="comment"
    />
  </div>
</template>

<script>
import TicketMessage from './TicketMessage'

export default {
  components: {
    TicketMessage,
  },
  props: {
    ticket: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style>

</style>
